// Sticky thumb is ~151px (small screens) / 80px (md+); do not reuse main gallery currentSrc widths.
const STICKY_THUMB_IMAGE_WIDTH_1X = 160;
const STICKY_THUMB_IMAGE_WIDTH_2X = 320;

class SubscriptionProductSingle {
  constructor() {
    this.root = document.querySelector('[data-subscription-product-single]');
    if (!this.root || !window.subscriptionFlow) {
      return;
    }

    this._searchParams = new URLSearchParams(window.location.search);
    this._redirectedCrateMode =
      this._searchParams.has('first_crate') && this._searchParams.has('product_handle');
    this.common =
      typeof subscriptionFunnalCommon !== 'undefined' ? subscriptionFunnalCommon.prototype : null;

    this.planInputs = Array.from(this.root.querySelectorAll('[data-subscription-type]'));
    this._planByProductType = new Map();
    for (let i = 0; i < this.planInputs.length; i++) {
      const el = this.planInputs[i];
      const t = el.getAttribute('product_type');
      if (t) {
        this._planByProductType.set(t, el);
      }
    }

    this.frequencySelect = this.root.querySelector('[data-sub-ship-frequency]');
    this.frequencyInputs = Array.from(this.root.querySelectorAll('[data-ship-frequency-option]'));
    this.paymentCards = Array.from(this.root.querySelectorAll('[data-pay-frequency]'));
    this.sizeWraps = Array.from(this.root.querySelectorAll('[data_size_dropdown_wrap]'));
    this.sizeInputs = Array.from(this.root.querySelectorAll('[data_size_dropdown]'));
    this.crateInputs = Array.from(this.root.querySelectorAll('[data-first-crate-checkbox]'));
    this.mainGallery = this.root.querySelector('.product-carousel');
    this.thumbGallery = this.root.querySelector('.product-thumbnails');
    this.mainGalleryWrapper = this.mainGallery
      ? this.mainGallery.querySelector('.swiper-wrapper')
      : null;
    this.thumbGalleryWrapper = this.thumbGallery
      ? this.thumbGallery.querySelector('.swiper-wrapper')
      : null;
    this.thumbGalleryContainer = this.thumbGallery
      ? this.thumbGallery.closest('[data-thumbSlider]')
      : null;
    this.galleryMainSlides = Array.from(this.root.querySelectorAll('[data-gallery-main-slide]'));
    this.galleryThumbSlides = this.thumbGalleryWrapper
      ? Array.from(this.thumbGalleryWrapper.querySelectorAll('.swiper-slide'))
      : [];
    this._activeGalleryKey = null;
    this._visibleGallerySignature = null;
    this._injectedProHandles = new Set();
    this._proGalleryFetchByHandle = new Map();
    this._insideCrateAccordionKey = null;
    this.planChooser = this.root.querySelector('.your-plan-wrap');
    this.crateChooser = this.root.querySelector('.your-first-crate-wrap');
    this.insideCrateAccordion = this.root.querySelector('[data-inside-crate-accordion]');
    this.paymentOptionsSwiperEl = this.root.querySelector('[data-payment-options-slider]');
    this._selectedPaymentCard = null;
    this._syncTimer = null;

    this.targets = {
      startingPrice: this.root.querySelector('[data-starting-price]'),
      shippingSummary: this.root.querySelector('[data-shipping-summary]'),
      paymentFrequencyLabel: this.root.querySelector('[data-payment-frequency-label]'),
      subtotal: this.root.querySelector('[data_crate_subtotal]'),
      discountRow: this.root.querySelector('[data-discount-row]'),
      discountSummary: this.root.querySelector('[data-discount-summary]')
    };
    this.mainSubmitButton =
      this.root.querySelector('.subscription-cta [data-submit-subscription]') ||
      this.root.querySelector('[data-submit-subscription]');
    this.sticky = {
      bar: document.querySelector('[data-sticky-subscription-bar]'),
      accordion: document.querySelector('[data-sticky-accordion]'),
      toggle: document.querySelector('[data-sticky-pdp-button]'),
      summaryToggle: document.querySelector('[data-sticky-summary-toggle]'),
      summary: document.querySelector('[data-sticky-summary]'),
      plan: document.querySelector('[data-sticky-plan]'),
      payment: document.querySelector('[data-sticky-payment]'),
      titleSeparator: document.querySelector('[data-sticky-title-sep]'),
      total: document.querySelector('[data-sticky-total]'),
      size: document.querySelector('[data-sticky-size]'),
      crate: document.querySelector('[data-sticky-crate]'),
      delivery: document.querySelector('[data-sticky-delivery]'),
      charge: document.querySelector('[data-sticky-charge]'),
      priceCurrent: document.querySelector('[data-sticky-price-current]'),
      priceCompare: document.querySelector('[data-sticky-price-compare]'),
      priceBadge: document.querySelector('[data-sticky-price-badge]'),
      desktopCompare: document.querySelector('[data-sticky-desktop-compare]'),
      desktopBadge: document.querySelector('[data-sticky-desktop-badge]'),
      buttonDivider: document.querySelector('[data-sticky-button-divider]'),
      buttonTotal: document.querySelector('[data-sticky-button-total]'),
      buttonCompare: document.querySelector('[data-sticky-button-compare]'),
      image: document.querySelector('[data-sticky-image]'),
      button: document.querySelector('[data-sticky-submit-subscription]')
    };
    this._mainSubmitObserver = null;
    this._stickyScrollHandler = null;
    this._stickySummaryOpen = false;

    this.bindEvents();
    this.setupStickyButtonMirror();
    this.setupStickyVisibility();
    this.applyUrlDerivedGlobals();
    this.applyRedirectedCrateMode();
    this.initState();

    for (let i = 0; i < this.sizeInputs.length; i++) {
      const input = this.sizeInputs[i];
      input.addEventListener('change', this._onSizeInputChange);
    }

    const productHandle = this._searchParams.get('product_handle');
    if (productHandle) {
      void this.fetchProductHandleForSpecialCrate(productHandle);
    } else {
      this.scheduleSyncFromState();
    }
  }

  _onSizeInputChange = () => {
    window.requestAnimationFrame(() => {
      this.onSizeChanged();
    });
  };

  applyUrlDerivedGlobals() {
    if (!this._searchParams.has('first_crate')) {
      return;
    }

    let firstCrate = decodeURIComponent(this._searchParams.get('first_crate') || '');
    firstCrate = firstCrate
      .replace(/_/g, '')
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');

    if (window.globalVariables) {
      window.globalVariables.first_crate_title = firstCrate;
    }
    window.subscriptionFlow.crateSKU = firstCrate;
    window.subscriptionFlow.crateName = firstCrate;

    const badge = document.querySelector('[data_crate_badge]');
    if (badge) {
      badge.textContent = firstCrate;
    }
  }

  applyRedirectedCrateMode() {
    if (!this._redirectedCrateMode) {
      return;
    }

    if (this.crateChooser) {
      this.crateChooser.classList.add('d-none');
    }

    this.syncRedirectedCrateState();
  }

  async fetchProductHandleForSpecialCrate(handle) {
    const safe = String(handle || '').replace(/[^a-z0-9\-_.]/gi, '');

    if (!safe) {
      this.scheduleSyncFromState();
      return;
    }

    try {
      const response = await fetch(`/products/${encodeURIComponent(safe)}.js`);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const product = await response.json();
      const variants = Array.isArray(product.variants) ? product.variants : [];

      window.specialCrate = variants;
      globalThis.specialCrate = variants;

      const availableTitles = new Set();
      for (let i = 0; i < variants.length; i++) {
        const v = variants[i];
        if (v.available) {
          availableTitles.add(v.title);
        }
      }

      const sizeInputs = this.root.querySelectorAll('input[data_size_dropdown]');
      for (let i = 0; i < sizeInputs.length; i++) {
        const input = sizeInputs[i];
        const title = input.getAttribute('data_size_dropdown') || input.value;
        if (title && !availableTitles.has(title)) {
          input.disabled = true;
          input.checked = false;
        } else if (title && availableTitles.has(title)) {
          input.disabled = false;
        }
      }

      if (typeof Utility !== 'undefined' && typeof Utility.getCookie === 'function') {
        const sizeCookie = Utility.getCookie('size_cookie');
        if (sizeCookie && sizeCookie !== 'undefined' && !availableTitles.has(sizeCookie)) {
          const fallback = availableTitles.values().next().value;
          if (fallback) {
            const inputs = this.root.querySelectorAll('input[data_size_dropdown]');
            for (let j = 0; j < inputs.length; j++) {
              const inp = inputs[j];
              const t = inp.getAttribute('data_size_dropdown') || inp.value;
              if (t === fallback) {
                inp.checked = true;
                inp.dispatchEvent(new Event('change', { bubbles: true }));
                break;
              }
            }
          }
        }
      }
    } catch (err) {
      if (window.SUBSCRIPTION_PRODUCT_DEBUG && typeof console !== 'undefined' && console.warn) {
        console.warn('[subscription-product] product_handle fetch failed', err);
      }
    } finally {
      this.scheduleSyncFromState();
    }
  }

  bindEvents() {
    for (let i = 0; i < this.planInputs.length; i++) {
      const input = this.planInputs[i];
      input.addEventListener('change', this._onPlanInputChange);
    }

    if (this.frequencySelect) {
      this.frequencySelect.addEventListener('change', this._onFrequencySelectChange);
    }

    for (let i = 0; i < this.frequencyInputs.length; i++) {
      this.frequencyInputs[i].addEventListener('change', this._onFrequencyInputChange);
    }

    for (let i = 0; i < this.paymentCards.length; i++) {
      const card = this.paymentCards[i];
      card.addEventListener('click', this._onPaymentCardClick);
      const radio = card.querySelector('[data-pay-checkobox]');
      if (radio) {
        radio.addEventListener('change', this._onPaymentCardRadioChange);
      }
    }

    for (let i = 0; i < this.crateInputs.length; i++) {
      this.crateInputs[i].addEventListener('change', this._onCrateInputChange);
    }

    const scrollDelivery = this.root.querySelector('[data-scroll-to-delivery]');
    if (scrollDelivery) {
      scrollDelivery.addEventListener('click', this._onScrollDeliveryClick);
    }

    if (this.sticky.toggle) {
      this.sticky.toggle.addEventListener('click', this._onStickySummaryToggle);
    }

    if (this.sticky.summaryToggle) {
      this.sticky.summaryToggle.addEventListener('click', this._onStickySummaryToggle);
    }

    if (this.sticky.button) {
      this.sticky.button.addEventListener('click', this._onStickySubmitClick);
    }

    this.setupInsideCrateAccordion();
    this.bindShirtFitToggles();
  }

  refreshPaymentOptionsSwiper() {
    const el = this.paymentOptionsSwiperEl || this.root.querySelector('[data-payment-options-slider]');
    if (!el) {
      return;
    }
    const inst = el.swiper;
    if (!inst || typeof inst.update !== 'function') {
      return;
    }
    inst.update();
    if (typeof inst.updateSize === 'function') {
      inst.updateSize();
    }
    const scrollbar = inst.scrollbar;
    if (scrollbar && typeof scrollbar.updateSize === 'function') {
      scrollbar.updateSize();
    }
  }

  schedulePaymentOptionsSwiperRefresh() {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        this.refreshPaymentOptionsSwiper();
      });
      window.setTimeout(() => {
        this.refreshPaymentOptionsSwiper();
      }, 120);
    });
  }

  /**
   * Inside-crate accordion: observe open state for Swiper layout, and expose helpers used when
   * plan / first-crate selections change (see syncInsideCrateAccordionFromSelections).
   */
  setupInsideCrateAccordion() {
    if (!this.insideCrateAccordion) {
      return;
    }
    const content = this.insideCrateAccordion.querySelector('[data-type="content"]');
    if (!content) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class' && content.classList.contains('open')) {
          this.scheduleInsideCrateSwiperLayoutRefresh();
          break;
        }
      }
    });
    observer.observe(content, { attributes: true, attributeFilter: ['class'] });

    if (content.classList.contains('open')) {
      this.scheduleInsideCrateSwiperLayoutRefresh();
    }
  }

  refreshInsideCrateSwiperLayout() {
    if (!this.insideCrateAccordion) {
      return;
    }
    const swiperEl = this.insideCrateAccordion.querySelector('.join-team-slider .swiper-slider');
    const sliderHost = this.insideCrateAccordion.querySelector('.join-team-slider');
    const inst = swiperEl && swiperEl.swiper;
    if (inst && typeof inst.update === 'function') {
      inst.update();
      if (typeof inst.updateSize === 'function') {
        inst.updateSize();
      }
      if (typeof inst.slideTo === 'function') {
        inst.slideTo(0, 0, false);
      }
    }
    if (typeof window.scheduleSliderTargetHeightUpdate === 'function') {
      window.scheduleSliderTargetHeightUpdate(sliderHost);
    }
  }

  scheduleInsideCrateSwiperLayoutRefresh() {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        this.refreshInsideCrateSwiperLayout();
      });
      window.setTimeout(() => {
        this.refreshInsideCrateSwiperLayout();
      }, 120);
    });
  }

  syncInsideCrateAccordionFromSelections() {
    if (!this.insideCrateAccordion || this._redirectedCrateMode) {
      return;
    }

    const slides = this.insideCrateAccordion.querySelectorAll('[data-inside-crate-slide]');
    if (!slides.length) {
      this._insideCrateAccordionKey = null;
      this.insideCrateAccordion.classList.add('sp-inside-crate-accordion--empty');
      return;
    }

    const flow = window.subscriptionFlow;
    const planType = flow ? flow.productType : '';
    const crateSlot = this.getSelectedCrateSlot();
    const visibilityKey = `${planType || ''}::${crateSlot || ''}`;

    if (this._insideCrateAccordionKey !== visibilityKey) {
      this._insideCrateAccordionKey = visibilityKey;

      for (let i = 0; i < slides.length; i++) {
        const slide = slides[i];
        const slidePlan = slide.getAttribute('data-sp-sub-type') || '';
        const slideCrate = slide.getAttribute('data-sp-crate-slot') || '';
        const planMatches = this._planActivationMatches(slidePlan, planType);
        const crateMatches = !!(crateSlot && slideCrate === crateSlot);
        const show = planMatches && crateMatches;
        slide.classList.toggle('d-none', !show);
      }

      this.scheduleInsideCrateSwiperLayoutRefresh();
    }

    this.applyInsideCrateAccordionEmptyState();
  }

  /**
   * Hide the whole inside-crate accordion when no slide is visible for the current plan + crate.
   * Uses a dedicated class so we do not strip redirect-mode `d-none` on the same node.
   */
  applyInsideCrateAccordionEmptyState() {
    if (!this.insideCrateAccordion || this._redirectedCrateMode) {
      return;
    }

    const slides = this.insideCrateAccordion.querySelectorAll('[data-inside-crate-slide]');
    let visibleCount = 0;
    for (let i = 0; i < slides.length; i++) {
      if (!slides[i].classList.contains('d-none')) {
        visibleCount += 1;
      }
    }

    this.insideCrateAccordion.classList.toggle('sp-inside-crate-accordion--empty', visibleCount === 0);
  }

  _onStickySubmitClick = (event) => {
    if (
      !this.mainSubmitButton ||
      this.mainSubmitButton.classList.contains('disabled') ||
      this.mainSubmitButton.classList.contains('soldout')
    ) {
      event.preventDefault();
      return;
    }
    this.mainSubmitButton.click();
  };

  _onStickySummaryToggle = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setStickySummaryOpen(!this._stickySummaryOpen);
  };

  _onPlanInputChange = (event) => {
    const input = event.currentTarget;
    if (!input.checked) {
      return;
    }
    this.applyPlanType(input.getAttribute('product_type'));
  };

  _onFrequencySelectChange = () => {
    this.setShipFrequency(this.frequencySelect.value, { fromSelect: true });
  };

  _onFrequencyInputChange = (event) => {
    const input = event.currentTarget;
    if (!input.checked) {
      return;
    }
    this.setShipFrequency(input.value);
  };

  _onPaymentCardClick = (event) => {
    this.selectPaymentCard(event.currentTarget);
  };

  _onPaymentCardRadioChange = (event) => {
    const radio = event.currentTarget;
    const card = radio.closest('[data-pay-frequency]');
    if (card) {
      this.selectPaymentCard(card);
    }
  };

  _onCrateInputChange = () => {
    window.requestAnimationFrame(() => {
      this.onCrateChanged();
    });
  };

  _onScrollDeliveryClick = (event) => {
    const btn = event && event.currentTarget;
    const wrap = this.root.querySelector('[data-sp-frequency-options-wrap]');
    if (wrap) {
      wrap.classList.remove('d-none');
      wrap.classList.add('open');
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (btn && typeof btn.setAttribute === 'function') {
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  bindShirtFitToggles() {
    const wraps = this.root.querySelectorAll('.sp-size-wrap[data_size_dropdown_wrap]');
    for (let w = 0; w < wraps.length; w++) {
      wraps[w].addEventListener('change', this._onShirtFitWrapChange);
    }
  }

  _onShirtFitWrapChange = (event) => {
    const input = event.target;
    if (
      !input ||
      !input.matches ||
      !input.matches('input[name="shirt_fit_classic"], input[name="shirt_fit_pro"]')
    ) {
      return;
    }
    if (!input.checked) {
      return;
    }
    const wrap = input.closest('.sp-size-wrap[data_size_dropdown_wrap]');
    if (!wrap) {
      return;
    }
    this.applyShirtFit(wrap, input.value);
  };

  setVisibleShirtPanel(wrap, fit) {
    if (!wrap || !fit) {
      return null;
    }

    const fitInputs = wrap.querySelectorAll(
      'input[name="shirt_fit_classic"], input[name="shirt_fit_pro"]'
    );
    for (let i = 0; i < fitInputs.length; i++) {
      fitInputs[i].checked = fitInputs[i].value === fit;
    }

    const panels = wrap.querySelectorAll('[data-shirt-panel]');
    let visiblePanel = null;
    for (let i = 0; i < panels.length; i++) {
      const panel = panels[i];
      const match = panel.getAttribute('data-shirt-panel') === fit;
      panel.hidden = !match;
      if (match) {
        visiblePanel = panel;
        continue;
      }

      const checked = panel.querySelectorAll('[data_size_dropdown]:checked');
      for (let j = 0; j < checked.length; j++) {
        checked[j].checked = false;
      }
    }

    return visiblePanel;
  }

  applyShirtFit(wrap, fit) {
    const visiblePanel = this.setVisibleShirtPanel(wrap, fit);
    const pick = visiblePanel
      ? visiblePanel.querySelector('[data_size_dropdown]:not([disabled])')
      : null;
    if (pick) {
      pick.checked = true;
      pick.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.updateCrateAvailability();
    this.ensureCrateSelection();
    const selectedCard = this.getSelectedPaymentCard();
    if (selectedCard && window.subscriptionFlow.productSize) {
      this.callCommon('setVariantDetails', selectedCard);
    }
    this.refreshSummary();
    this.updateButtonState();
    this.syncGalleryFromSelections();
  }

  initState() {
    const currentProduct = this._searchParams.get('currentProduct');

    if (currentProduct === 'platecrate_pro') {
      const proInput = this._planByProductType.get('platecrate-pro');
      if (proInput) {
        proInput.checked = true;
      }
    }

    if (currentProduct === 'platecrate_lite') {
      const liteInput = this._planByProductType.get('platecrate-lite');
      if (liteInput) {
        liteInput.checked = true;
      }
    }

    const selectedPlan = this.getSelectedPlanInput() || this.planInputs[0];
    if (selectedPlan && !selectedPlan.checked) {
      selectedPlan.checked = true;
    }

    this.applyPlanType(
      selectedPlan ? selectedPlan.getAttribute('product_type') : 'platecrate',
      { keepFrequency: true }
    );

    const selectedFrequency = this.getSelectedFrequencyInput();
    const fallbackFrequency =
      this.frequencySelect && this.frequencySelect.value ? this.frequencySelect.value : '1';
    this.setShipFrequency(
      selectedFrequency ? selectedFrequency.value : fallbackFrequency,
      { keepPaymentSelection: false }
    );

    this.ensureValidSelections();
    this.lockRedirectedSelections();
    this.refreshSummary();
    this.updateButtonState();
    this.syncGalleryFromSelections();
  }

  syncFromState() {
    const flow = window.subscriptionFlow;

    if (flow.productType) {
      const planInput = this._planByProductType.get(flow.productType);
      if (planInput) {
        planInput.checked = true;
      }
      this.applyPlanType(flow.productType, { keepFrequency: true });
    }

    if (flow.shipFrequency) {
      this.setShipFrequency(String(flow.shipFrequency), {
        fromSelect: true,
        keepPaymentSelection: false
      });
    } else if (this.frequencySelect && this.frequencySelect.value) {
      this.setShipFrequency(this.frequencySelect.value, {
        fromSelect: true,
        keepPaymentSelection: false
      });
    }

    this.ensureValidSelections();
    this.lockRedirectedSelections();
    this.refreshSummary();
    this.updateButtonState();
    this.syncGalleryFromSelections();
  }

  lockRedirectedSelections() {
    if (!this._redirectedCrateMode) {
      return;
    }

    if (this.planChooser) {
      this.planChooser.classList.add('d-none');
    }

    if (this.insideCrateAccordion) {
      this.insideCrateAccordion.classList.add('d-none');
    }

    for (let i = 0; i < this.planInputs.length; i++) {
      this.planInputs[i].disabled = true;
    }
  }

  applyPlanType(productType, options = {}) {
    if (!productType) {
      return;
    }

    window.subscriptionFlow.productType = productType;

    const activeWrap =
      this.root.querySelector(`[data_size_dropdown_wrap="${productType}"]`) ||
      this.sizeWraps[0] ||
      null;
    for (let i = 0; i < this.sizeWraps.length; i++) {
      this.sizeWraps[i].classList.toggle('d-none', this.sizeWraps[i] !== activeWrap);
    }

    if (activeWrap) {
      this.ensureSizeSelected(activeWrap);
    }

    if (!options.keepFrequency) {
      const selectedFrequency = this.getSelectedFrequencyInput();
      if (selectedFrequency) {
        this.setShipFrequency(selectedFrequency.value);
      }
    }

    this.filterPaymentCards();
    this.ensureSelectedPaymentCard();
    this.updateCrateAvailability();
    this.ensureCrateSelection();
    this.refreshSummary();
    this.updateButtonState();
    this.syncGalleryFromSelections();
  }

  setShipFrequency(value, options = {}) {
    const shipFrequency = parseInt(value, 10);
    if (!Number.isFinite(shipFrequency)) {
      return;
    }

    window.subscriptionFlow.shipFrequency = shipFrequency;
    window.subscriptionFlow.frequency = this.mapFlowFrequency(shipFrequency);

    if (!options.fromSelect && this.frequencySelect) {
      this.frequencySelect.value = String(shipFrequency);
    }

    for (let i = 0; i < this.frequencyInputs.length; i++) {
      const input = this.frequencyInputs[i];
      input.checked = parseInt(input.value, 10) === shipFrequency;
    }

    this.filterPaymentCards();

    if (!options.keepPaymentSelection) {
      this.ensureSelectedPaymentCard();
    }

    this.updateCrateAvailability();
    this.ensureCrateSelection();
    this.refreshSummary();
    this.updateButtonState();
    this.syncGalleryFromSelections();
  }

  filterPaymentCards() {
    const flow = window.subscriptionFlow;
    const shipFrequency = parseInt(flow.shipFrequency, 10);

    for (let i = 0; i < this.paymentCards.length; i++) {
      const card = this.paymentCards[i];
      const cardType = card.getAttribute('data-product-type');
      const cardShipFrequency = parseInt(card.getAttribute('data-ship-frequency'), 10);
      const shouldShow = cardType === flow.productType && cardShipFrequency === shipFrequency;
      card.classList.toggle('d-none', !shouldShow);
    }

    this.schedulePaymentOptionsSwiperRefresh();
  }

  ensureSelectedPaymentCard() {
    let visibleChecked = null;
    for (let i = 0; i < this.paymentCards.length; i++) {
      const card = this.paymentCards[i];
      if (card.classList.contains('d-none')) {
        continue;
      }
      const radio = card.querySelector('[data-pay-checkobox]');
      if (radio && radio.checked) {
        visibleChecked = card;
        break;
      }
    }

    if (visibleChecked) {
      if (this._selectedPaymentCard === visibleChecked) {
        return;
      }
      this.selectPaymentCard(visibleChecked);
      return;
    }

    let firstVisible = null;
    for (let i = 0; i < this.paymentCards.length; i++) {
      if (!this.paymentCards[i].classList.contains('d-none')) {
        firstVisible = this.paymentCards[i];
        break;
      }
    }

    if (firstVisible) {
      const radio = firstVisible.querySelector('[data-pay-checkobox]');
      if (radio) {
        radio.checked = true;
      }
      this.selectPaymentCard(firstVisible);
    } else {
      this._selectedPaymentCard = null;
      window.subscriptionFlow.payFrequency = null;
      window.subscriptionFlow.subTotal = null;
    }
  }

  selectPaymentCard(card) {
    if (!card || card.classList.contains('d-none')) {
      return;
    }

    const radio = card.querySelector('[data-pay-checkobox]');
    if (radio) {
      radio.checked = true;
    }
    this._selectedPaymentCard = card;

    const payFrequency = parseInt(card.getAttribute('data-pay-frequency'), 10);
    const subTotal = card.querySelector('[data-sub-total]');
    const subscriptionPrice = card.querySelector('[data-subscription-price]');
    const shipping = card.querySelector('[free_shipping]');

    window.subscriptionFlow.payFrequency = Number.isFinite(payFrequency) ? payFrequency : null;
    window.subscriptionFlow.subTotal = subTotal ? subTotal.textContent.trim() : null;
    window.subscriptionFlow.subscriptionprice = subscriptionPrice
      ? subscriptionPrice.textContent.trim()
      : null;
    window.subscriptionFlow.freeShipping = shipping ? shipping.textContent.trim() : '';

    if (window.subscriptionFlow.freeShipping === '+ S/H') {
      window.subscriptionFlow.freeShipping = '+ Shipping & Handling';
    }

    window.subscriptionFlow.giftVariantId = card.getAttribute('gift_variant_id') || null;
    window.subscriptionFlow.giftNote = card.getAttribute('gift_product_note') || '';

    if (window.subscriptionFlow.productSize) {
      this.callCommon('setVariantDetails', card);
    }

    this.syncGiftBanner(card.getAttribute('main_product_id'));

    const checkedCrate = this.getSelectedCrateInput();
    if (!this._redirectedCrateMode && checkedCrate && window.subscriptionFlow.productSize) {
      this.callCommon('_selectCrate', checkedCrate);
    }

    this.refreshSummary();
    this.updateButtonState();
  }

  syncGiftBanner(mainProductId) {
    let isGiftVisible = false;
    const gifts = this.root.querySelectorAll('[gift_main_product_id]');
    const flowType = window.subscriptionFlow.productType;

    for (let i = 0; i < gifts.length; i++) {
      const gift = gifts[i];
      const giftMainProductId = gift.getAttribute('gift_main_product_id');
      const giftProductType = gift.getAttribute('product_type');
      const shouldShow = giftMainProductId === mainProductId && giftProductType === flowType;
      gift.classList.toggle('d-none', !shouldShow);

      if (shouldShow) {
        window.subscriptionFlow.giftVariantId =
          gift.getAttribute('data-gift-variant-id') || window.subscriptionFlow.giftVariantId;
        isGiftVisible = true;
      }
    }

    if (!isGiftVisible) {
      window.subscriptionFlow.giftVariantId = null;
    }
  }

  onSizeChanged() {
    this.updateCrateAvailability();
    this.ensureCrateSelection();

    const selectedCard = this.getSelectedPaymentCard();
    if (selectedCard && window.subscriptionFlow.productSize) {
      this.callCommon('setVariantDetails', selectedCard);
    }

    this.refreshSummary();
    this.updateButtonState();
    this.syncGalleryFromSelections();
  }

  onCrateChanged() {
    if (this._redirectedCrateMode) {
      this.syncRedirectedCrateState();
      this.refreshSummary();
      this.updateButtonState();
      this.syncGalleryFromSelections();
      return;
    }

    const activeWrap = this.getActiveSizeWrap();
    this.updateSizeAvailability(activeWrap);
    this.ensureSizeSelected(activeWrap);

    const checked = this.getSelectedCrateInput();
    if (checked && !checked.disabled && window.subscriptionFlow.productSize) {
      this.callCommon('_selectCrate', checked);
    }
    this.refreshSummary();
    this.updateButtonState();
    this.syncGalleryFromSelections();
  }

  syncRedirectedCrateState() {
    if (!this._redirectedCrateMode) {
      return;
    }

    if (this.crateChooser) {
      this.crateChooser.classList.add('d-none');
    }

    for (let i = 0; i < this.crateInputs.length; i++) {
      this.crateInputs[i].checked = false;
      this.crateInputs[i].disabled = true;
    }

    const firstCrateTitle =
      (window.globalVariables && window.globalVariables.first_crate_title) ||
      window.subscriptionFlow.crateName ||
      null;

    if (firstCrateTitle) {
      window.subscriptionFlow.crateName = firstCrateTitle;
      if (!window.subscriptionFlow.crateSKU) {
        window.subscriptionFlow.crateSKU = firstCrateTitle;
      }
    }

    if (!window.subscriptionFlow.productSize) {
      return;
    }

    const redirectedVariants = Array.isArray(globalThis.specialCrate)
      ? globalThis.specialCrate
      : Array.isArray(window.specialCrate)
        ? window.specialCrate
        : null;

    if (!redirectedVariants || !redirectedVariants.length) {
      return;
    }

    const currentVariant = redirectedVariants.find(
      (variant) => variant && variant.title === window.subscriptionFlow.productSize
    );

    if (currentVariant && currentVariant.sku) {
      window.subscriptionFlow.crateSKU = currentVariant.sku;
    }
  }

  static _selectOptionForSize(selectEl, productSize) {
    const opts = selectEl.options;
    for (let i = 0; i < opts.length; i++) {
      const option = opts[i];
      if (option.dataset.variantTitle === productSize) {
        return option;
      }
    }
    return null;
  }

  getActiveSizeWrap() {
    return (
      this.root.querySelector(`[data_size_dropdown_wrap="${window.subscriptionFlow.productType}"]`) ||
      this.sizeWraps.find((wrap) => this.isVisible(wrap)) ||
      this.sizeWraps[0] ||
      null
    );
  }

  getCrateSourceForWrap(wrap) {
    if (!wrap) {
      return null;
    }

    const classicSelect =
      wrap.querySelector('select[plateCrate]') || wrap.querySelector('select[platecrate]');
    const proSelect =
      wrap.querySelector('select[plateCratePRO]') || wrap.querySelector('select[platecratepro]');
    const surpriseInput = wrap.querySelector('input[data-crate-value][value="surprise"]');

    if (window.subscriptionFlow.productType === 'platecrate-pro') {
      return proSelect || surpriseInput;
    }

    return classicSelect || surpriseInput;
  }

  getFirstSelectableCrateInput() {
    for (let i = 0; i < this.crateInputs.length; i++) {
      const input = this.crateInputs[i];
      const wrap = input.closest('[data-first-crate-wrap]');
      if (!input.disabled && this.isVisible(wrap)) {
        return input;
      }
    }

    return null;
  }

  updateSizeAvailability(activeWrap = this.getActiveSizeWrap()) {
    if (this._redirectedCrateMode || !activeWrap) {
      return;
    }

    const selectedCrate = this.getSelectedCrateInput() || this.getFirstSelectableCrateInput();
    const selectedWrap = selectedCrate ? selectedCrate.closest('[data-first-crate-wrap]') : null;
    const source = this.getCrateSourceForWrap(selectedWrap);
    const radios = activeWrap.querySelectorAll('[data_size_dropdown]');

    if (!source || source.tagName !== 'SELECT') {
      for (let i = 0; i < radios.length; i++) {
        radios[i].disabled = false;
      }
      return;
    }

    const availableTitles = new Set();
    const options = source.options || [];
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      if (option.dataset.available === 'true' && option.dataset.variantTitle) {
        availableTitles.add(option.dataset.variantTitle);
      }
    }

    for (let i = 0; i < radios.length; i++) {
      const input = radios[i];
      const title = input.getAttribute('data_size_dropdown') || input.value;
      const isAvailable = availableTitles.has(title);
      input.disabled = !isAvailable;
      if (!isAvailable && input.checked) {
        input.checked = false;
      }
    }
  }

  updateCrateAvailability() {
    if (this._redirectedCrateMode) {
      this.syncRedirectedCrateState();
      return;
    }

    const flow = window.subscriptionFlow;

    for (let c = 0; c < this.crateInputs.length; c++) {
      const crateInput = this.crateInputs[c];
      const wrap = crateInput.closest('[data-first-crate-wrap]');
      if (!wrap) {
        continue;
      }

      const activeCrateSource = this.getCrateSourceForWrap(wrap);

      let isSelectable = true;

      if (!activeCrateSource) {
        isSelectable = false;
      } else if (activeCrateSource.tagName === 'SELECT') {
        isSelectable = false;
        const options = activeCrateSource.options || [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].dataset.available === 'true') {
            isSelectable = true;
            break;
          }
        }
      }

      if (!this.isVisible(wrap)) {
        isSelectable = false;
      }

      crateInput.disabled = !isSelectable;
      wrap.classList.toggle('sp-first-crate-disabled', !isSelectable);

      if (!isSelectable && crateInput.checked) {
        crateInput.checked = false;
      }
    }
  }

  ensureCrateSelection() {
    if (this._redirectedCrateMode) {
      this.syncRedirectedCrateState();
      return;
    }

    const checked = this.getSelectedCrateInput();
    const wrapChecked = checked ? checked.closest('[data-first-crate-wrap]') : null;
    if (
      checked &&
      window.subscriptionFlow.productSize &&
      !checked.disabled &&
      this.isVisible(wrapChecked)
    ) {
      this.callCommon('_selectCrate', checked);
      return;
    }

    for (let i = 0; i < this.crateInputs.length; i++) {
      const input = this.crateInputs[i];
      const wrap = input.closest('[data-first-crate-wrap]');
      if (!input.disabled && this.isVisible(wrap)) {
        input.checked = true;
        input.dispatchEvent(new Event('click', { bubbles: true }));
        return;
      }
    }

    window.subscriptionFlow.crateSKU = null;
    window.subscriptionFlow.crateName = null;
  }

  ensureSizeSelected(activeWrap) {
    if (!activeWrap) {
      return;
    }

    let visiblePanel = activeWrap.querySelector('.sp-size-panel:not([hidden])');
    let scope = visiblePanel || activeWrap;

    const desiredSize = window.subscriptionFlow.productSize;
    if (desiredSize) {
      const allRadios = activeWrap.querySelectorAll('[data_size_dropdown]');
      for (let i = 0; i < allRadios.length; i++) {
        const input = allRadios[i];
        const title = input.getAttribute('data_size_dropdown') || input.value;
        if (title !== desiredSize || input.disabled) {
          continue;
        }

        const panel = input.closest('.sp-size-panel');
        if (panel) {
          const fit = panel.getAttribute('data-shirt-panel');
          if (fit) {
            visiblePanel = this.setVisibleShirtPanel(activeWrap, fit);
            scope = visiblePanel || activeWrap;
          }
        }

        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }

    const currentChecked = scope.querySelector('[data_size_dropdown]:checked');
    if (currentChecked && this.isVisible(currentChecked.closest('.sp-size-panel') || currentChecked)) {
      window.subscriptionFlow.productSize = currentChecked.value;
      return;
    }

    let radios = scope.querySelectorAll('[data_size_dropdown]');
    for (let i = 0; i < radios.length; i++) {
      const input = radios[i];
      const panel = input.closest('.sp-size-panel');
      if (
        !input.disabled &&
        (!panel || !panel.hidden) &&
        this.isVisible(panel || input)
      ) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }

    radios = activeWrap.querySelectorAll('[data_size_dropdown]');
    for (let i = 0; i < radios.length; i++) {
      const input = radios[i];
      const panel = input.closest('.sp-size-panel');
      if (!input.disabled) {
        if (panel) {
          const fit = panel.getAttribute('data-shirt-panel');
          if (fit) {
            visiblePanel = this.setVisibleShirtPanel(activeWrap, fit);
            scope = visiblePanel || activeWrap;
          }
        }
        if (this.isVisible(panel || input)) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
    }

    window.subscriptionFlow.productSize = null;
  }

  refreshSummary() {
    const flow = window.subscriptionFlow;
    const t = this.targets;

    const shipFrequency = parseInt(flow.shipFrequency, 10);
    const shipFrequencyText = this.getShipFrequencyLabel(shipFrequency);

    const subTotalRaw = flow.subTotal || '-';

    if (t.shippingSummary) {
      t.shippingSummary.textContent = flow.freeShipping || '-';
    }
    if (t.paymentFrequencyLabel) {
      if (shipFrequencyText === '-') {
        t.paymentFrequencyLabel.textContent = '';
      } else {
        const normalizedShipFrequencyText = String(shipFrequencyText).replace(/^Every\s+/i, '');
        t.paymentFrequencyLabel.textContent = `Delivered ${normalizedShipFrequencyText}`;
      }
    }

    const discountState = this.getDiscountState();

    if (t.subtotal) {
      if (discountState.hasDiscount) {
        t.subtotal.innerHTML = `<span class="sp-price-old">${subTotalRaw}</span> <span class="sp-price-new">${discountState.discountedTotalFormatted}</span>`;
      } else {
        t.subtotal.textContent = subTotalRaw;
      }
    }

    if (t.discountRow && t.discountSummary) {
      t.discountRow.classList.toggle('d-none', !discountState.hasDiscount);
      if (discountState.hasDiscount) {
        t.discountSummary.textContent = `Save ${discountState.savingsFormatted}`;
      }
    }

    this.updateHeroPlanHighlights();
    this.updateStickyBar(discountState);
  }

  updateHeroPlanHighlights() {
    const selectedPlan = this.getSelectedPlanInput();
    if (!selectedPlan) {
      return;
    }

    const t = this.targets;
    const planCard = selectedPlan.closest('.sp-plan-card');
    let startingPrice = this.normalizeStartingPrice(
      selectedPlan.getAttribute('data-plan-starting-price')
    );
    if (!startingPrice && planCard) {
      const cardPriceLabel = planCard.querySelector('.plan-price .text-secondary');
      const rawPrice = cardPriceLabel ? cardPriceLabel.textContent.replace(/\s+/g, ' ').trim() : '';
      startingPrice = this.normalizeStartingPrice(rawPrice);
    }

    if (t.startingPrice && startingPrice) {
      t.startingPrice.textContent = startingPrice;
    }
  }

  normalizeStartingPrice(value) {
    const text = String(value || '').replace(/\s+/g, ' ').trim();
    if (!text) {
      return '';
    }

    const amountMatch = text.match(/\$\s*\d+(?:[.,]\d+)?/);
    if (!amountMatch || !amountMatch[0]) {
      return '';
    }

    return amountMatch[0].replace(/\s+/g, '');
  }

  getSelectedCrateSlot() {
    const checked = this.getSelectedCrateInput();
    if (!checked) {
      return null;
    }

    const directSlot = checked.getAttribute('data-crate-slot');
    if (directSlot) {
      return directSlot;
    }

    const wrap = checked.closest('[data-crate-slot]');
    return wrap ? wrap.getAttribute('data-crate-slot') : null;
  }

  getGallerySelectionKey() {
    const planType = window.subscriptionFlow.productType;
    const crateSlot = this.getSelectedCrateSlot();

    if (!planType || !crateSlot) {
      return null;
    }

    return `${planType}::${crateSlot}`;
  }

  syncGalleryFromSelections() {
    if (this.galleryMainSlides.length) {
      void this._resolveAndRenderGallery();
    }

    this.syncInsideCrateAccordionFromSelections();
  }

  async _resolveAndRenderGallery() {
    const planType = this._normalizePlanType(window.subscriptionFlow.productType);
    const crateSlot = this.getSelectedCrateSlot();
    let indices = this.getMatchingGalleryIndices();

    if (planType === 'platecrate-pro' && crateSlot && !indices.length) {
      await this.ensureProGallerySlides(crateSlot);
      indices = this.getMatchingGalleryIndices();
    }

    if (!indices.length && crateSlot && planType === 'platecrate-pro') {
      indices = this._collectGalleryIndices({ planType: 'platecrate', crateSlot });
    }

    if (!indices.length) {
      indices = this.galleryMainSlides.map((_, index) => index);
    }

    const key = `${this.getGallerySelectionKey() || '__default__'}::${indices.join(',')}`;
    if (this._activeGalleryKey === key) {
      return;
    }

    this._activeGalleryKey = key;
    this.renderMatchingGallerySlides(indices);
    this.activateGalleryImageForSelection();
    this.syncStickyImage();
  }

  activateGalleryImageForSelection(attempt = 0) {
    const mainSwiper = this.mainGallery && this.mainGallery.swiper ? this.mainGallery.swiper : null;
    const thumbSwiper = this.thumbGallery && this.thumbGallery.swiper ? this.thumbGallery.swiper : null;

    if (!mainSwiper) {
      if (attempt < 10) {
        window.setTimeout(() => {
          this.activateGalleryImageForSelection(attempt + 1);
        }, 120);
      }
      return;
    }

    const hasRenderedSlides =
      this.mainGalleryWrapper &&
      this.mainGalleryWrapper.querySelector('.swiper-slide');
    if (!hasRenderedSlides) {
      return;
    }

    const index = 0;

    if (thumbSwiper) {
      thumbSwiper.slideTo(index, 300, false);
    }
    mainSwiper.slideTo(index, 300, false);
  }

  _normalizePlanType(planType) {
    if (!planType) {
      return planType;
    }
    if (planType === 'platecrate_pro') {
      return 'platecrate-pro';
    }
    return planType;
  }

  _planActivationMatches(slidePlan, planType) {
    const normalizedPlanType = this._normalizePlanType(planType);

    if (!slidePlan) {
      return true;
    }
    if (slidePlan === normalizedPlanType) {
      return true;
    }
    if (slidePlan === 'standard-and-pro') {
      return normalizedPlanType === 'platecrate' || normalizedPlanType === 'platecrate-pro';
    }
    return false;
  }

  _collectGalleryIndices({ planType, crateSlot, productHandle, defaultsOnly } = {}) {
    const indices = [];
    const normalizedPlan = planType ? this._normalizePlanType(planType) : null;

    for (let i = 0; i < this.galleryMainSlides.length; i++) {
      const slide = this.galleryMainSlides[i];
      if (!slide) {
        continue;
      }

      const slidePlan = slide.getAttribute('data-activation-plan-type') || '';
      const slideCrate = slide.getAttribute('data-activation-crate-slot') || '';
      const slideHandle = slide.getAttribute('data-gallery-product-handle') || '';

      if (defaultsOnly) {
        if (!slidePlan && !slideCrate) {
          indices.push(i);
        }
        continue;
      }

      if (productHandle) {
        if (slideHandle === productHandle && this._planActivationMatches(slidePlan, planType)) {
          indices.push(i);
        }
        continue;
      }

      if (!slidePlan && !slideCrate) {
        continue;
      }

      const planMatches = this._planActivationMatches(slidePlan, normalizedPlan);
      const crateMatches = !slideCrate || slideCrate === crateSlot;

      if (planMatches && crateMatches) {
        indices.push(i);
      }
    }

    return indices;
  }

  _getProHandleForCrate(crateSlot) {
    const standardIndices = this._collectGalleryIndices({
      planType: 'platecrate',
      crateSlot
    });
    if (!standardIndices.length) {
      return null;
    }

    const handle = this.galleryMainSlides[standardIndices[0]]?.getAttribute(
      'data-gallery-product-handle'
    );
    if (!handle) {
      return null;
    }

    return handle.endsWith('-pro') ? handle : `${handle}-pro`;
  }

  _createGallerySlidePair(image, { handle, planType, crateSlot, index, title }) {
    const src = typeof image === 'string' ? image : image.src;
    const alt = (typeof image === 'object' && image.alt) || title || '';
    const mediaId =
      typeof image === 'object' && image.id ? String(image.id) : `injected-${handle}-${index}`;
    const mainSrc = this.getShopifyImageWithWidth(src, 900) || src;
    const thumbSrc = this.getShopifyImageWithWidth(src, 120) || src;

    const mainSlide = document.createElement('div');
    mainSlide.className =
      'swiper-slide carousel-cell d-flex align-items-center product--media';
    mainSlide.setAttribute('data-mediaID', mediaId);
    mainSlide.setAttribute('data-gallery-main-slide', '');
    mainSlide.setAttribute('data-gallery-product-handle', handle);
    mainSlide.setAttribute('data-activation-plan-type', planType);
    mainSlide.setAttribute('data-activation-crate-slot', crateSlot);
    mainSlide.setAttribute('data-gallery-injected', 'true');
    mainSlide.innerHTML = `<picture class="d-block position-relative w-100 h-100">
      <img src="${mainSrc}" alt="${alt.replace(/"/g, '&quot;')}" loading="${index === 0 ? 'eager' : 'lazy'}"
        class="position-absolute w-100 h-100 top-0 bottom-0 start-0 end-0" style="object-fit: contain;">
    </picture>`;

    const thumbSlide = document.createElement('div');
    thumbSlide.className = 'swiper-slide';
    thumbSlide.innerHTML = `<div class="product-thumb--image" data-gallery-thumb-slide data-mediaID="${mediaId}">
      <img class="img-fluid" src="${thumbSrc}" alt="${alt.replace(/"/g, '&quot;')}" loading="lazy">
    </div>`;

    return { mainSlide, thumbSlide };
  }

  _injectGallerySlidesFromProduct(product, planType, crateSlot) {
    const handle = product?.handle;
    const images = Array.isArray(product?.images) ? product.images : [];

    if (!handle || !images.length || this._injectedProHandles.has(handle)) {
      return;
    }

    for (let i = 0; i < images.length; i++) {
      const { mainSlide, thumbSlide } = this._createGallerySlidePair(images[i], {
        handle,
        planType,
        crateSlot,
        index: i,
        title: product.title
      });
      this.galleryMainSlides.push(mainSlide);
      this.galleryThumbSlides.push(thumbSlide);
    }

    this._injectedProHandles.add(handle);
  }

  async ensureProGallerySlides(crateSlot) {
    const proHandle = this._getProHandleForCrate(crateSlot);
    if (!proHandle || this._injectedProHandles.has(proHandle)) {
      return;
    }

    if (
      this._collectGalleryIndices({
        planType: 'platecrate-pro',
        productHandle: proHandle
      }).length
    ) {
      return;
    }

    if (this._proGalleryFetchByHandle.has(proHandle)) {
      return this._proGalleryFetchByHandle.get(proHandle);
    }

    const safeHandle = String(proHandle).replace(/[^a-z0-9\-_.]/gi, '');
    const fetchPromise = fetch(`/products/${encodeURIComponent(safeHandle)}.js`)
      .then((response) => (response.ok ? response.json() : null))
      .then((product) => {
        if (product) {
          this._injectGallerySlidesFromProduct(product, 'platecrate-pro', crateSlot);
        }
      })
      .catch((error) => {
        if (window.SUBSCRIPTION_PRODUCT_DEBUG && typeof console !== 'undefined' && console.warn) {
          console.warn('[subscription-product] pro gallery fetch failed', error);
        }
      })
      .finally(() => {
        this._proGalleryFetchByHandle.delete(proHandle);
      });

    this._proGalleryFetchByHandle.set(proHandle, fetchPromise);
    return fetchPromise;
  }

  getMatchingGalleryIndices() {
    const planType = this._normalizePlanType(window.subscriptionFlow.productType);
    const crateSlot = this.getSelectedCrateSlot();

    const exact = this._collectGalleryIndices({ planType, crateSlot });
    if (exact.length) {
      return exact;
    }

    if (planType === 'platecrate-pro' && crateSlot) {
      const proHandle = this._getProHandleForCrate(crateSlot);
      const paired = this._collectGalleryIndices({
        planType,
        productHandle: proHandle
      });
      if (paired.length) {
        return paired;
      }
    }

    return this._collectGalleryIndices({ defaultsOnly: true });
  }

  _refreshSwiper(swiper) {
    if (!swiper) {
      return;
    }

    if (typeof swiper.updateSlides === 'function') {
      swiper.updateSlides();
    }
    if (typeof swiper.updateProgress === 'function') {
      swiper.updateProgress();
    }
    if (typeof swiper.update === 'function') {
      swiper.update();
    }
    if (typeof swiper.slideTo === 'function') {
      swiper.slideTo(0, 0, false);
    }
  }

  refreshProductGallerySwipers() {
    this._refreshSwiper(this.mainGallery && this.mainGallery.swiper);
    this._refreshSwiper(this.thumbGallery && this.thumbGallery.swiper);
  }

  renderMatchingGallerySlides(indices) {
    if (!this.mainGalleryWrapper) {
      return;
    }

    const normalizedIndices =
      Array.isArray(indices) && indices.length
        ? indices
        : this.galleryMainSlides.map((_, index) => index);
    const selectionKey = this.getGallerySelectionKey() || '__default__';
    const signature = `${selectionKey}::${normalizedIndices.join(',')}`;

    if (this._visibleGallerySignature === signature) {
      return;
    }

    this._visibleGallerySignature = signature;

    while (this.mainGalleryWrapper.firstChild) {
      this.mainGalleryWrapper.removeChild(this.mainGalleryWrapper.firstChild);
    }

    const mainFragment = document.createDocumentFragment();
    for (let i = 0; i < normalizedIndices.length; i++) {
      const slide = this.galleryMainSlides[normalizedIndices[i]];
      if (slide) {
        mainFragment.appendChild(slide);
      }
    }
    this.mainGalleryWrapper.appendChild(mainFragment);

    if (this.thumbGalleryWrapper) {
      while (this.thumbGalleryWrapper.firstChild) {
        this.thumbGalleryWrapper.removeChild(this.thumbGalleryWrapper.firstChild);
      }

      const thumbFragment = document.createDocumentFragment();
      for (let i = 0; i < normalizedIndices.length; i++) {
        const thumbSlide = this.galleryThumbSlides[normalizedIndices[i]];
        if (thumbSlide) {
          thumbFragment.appendChild(thumbSlide);
        }
      }
      this.thumbGalleryWrapper.appendChild(thumbFragment);
    }

    this.refreshProductGallerySwipers();
  }

  updateButtonState() {
    this.callCommon('isAllDetailSelected');
    if (typeof window.restoreSubscriptionProductCtaLabels === 'function') {
      window.restoreSubscriptionProductCtaLabels();
    }
    this.syncStickyButtonFromMain();
  }

  setupStickyButtonMirror() {
    if (
      !this.mainSubmitButton ||
      !this.sticky.button ||
      typeof MutationObserver === 'undefined'
    ) {
      return;
    }

    this._mainSubmitObserver = new MutationObserver(() => {
      this.syncStickyButtonFromMain();
    });
    this._mainSubmitObserver.observe(this.mainSubmitButton, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      childList: true,
      characterData: true,
      subtree: true
    });
    this.syncStickyButtonFromMain();
  }

  setupStickyVisibility() {
    if (!this.sticky.bar) {
      return;
    }

    const ctaAnchor =
      this.root.querySelector('[data-next-flow-btn]') ||
      (this.mainSubmitButton && this.mainSubmitButton.closest('.subscription-cta')) ||
      this.mainSubmitButton;

    if (!ctaAnchor) {
      this.setStickyActive(false);
      return;
    }

    // Only show the sticky CTA after the in-page CTA has scrolled above the viewport.
    // If we used plain "not intersecting", the bar would appear on load whenever the main
    // CTA is below the fold — before users see plan copy ("starting at…") vs checkout price.
    const updateVisibilityFromRect = () => {
      const rect = ctaAnchor.getBoundingClientRect();
      const scrolledPastCta = rect.bottom <= 0;
      this.setStickyActive(scrolledPastCta);
    };

    this._stickyScrollHandler = updateVisibilityFromRect;
    window.addEventListener('scroll', this._stickyScrollHandler, { passive: true });
    window.addEventListener('resize', this._stickyScrollHandler);
    updateVisibilityFromRect();
  }

  setStickyActive(isActive) {
    if (!this.sticky.bar) {
      return;
    }
    this.sticky.bar.classList.toggle('active', !!isActive);
  }

  syncStickyButtonFromMain() {
    if (!this.mainSubmitButton || !this.sticky.button) {
      return;
    }

    const stickyButton = this.sticky.button;
    const isSoldOut = this.mainSubmitButton.classList.contains('soldout');
    const isDisabled =
      this.mainSubmitButton.disabled ||
      this.mainSubmitButton.classList.contains('disabled') ||
      isSoldOut;
    stickyButton.disabled = isDisabled;
    stickyButton.classList.toggle('disabled', this.mainSubmitButton.classList.contains('disabled'));
    stickyButton.classList.toggle('soldout', isSoldOut);
    stickyButton.classList.toggle('loading', this.mainSubmitButton.classList.contains('loading'));

    const mainLabel = this.mainSubmitButton.querySelector('.add-text');
    const stickyLabel = stickyButton.querySelector('.add-text');
    if (mainLabel && stickyLabel) {
      stickyLabel.textContent = mainLabel.textContent.replace(/\s+/g, ' ').trim();
    }
  }

  updateStickyBar(discountState = this.getDiscountState()) {
    if (!this.sticky.bar) {
      return;
    }

    const plan = this.getSelectedPlanLabel();
    const payment = this.getSelectedPaymentLabel();
    const total =
      discountState && discountState.hasDiscount
        ? discountState.discountedTotalFormatted
        : window.subscriptionFlow.subTotal || '';
    const size = window.subscriptionFlow.productSize || '-';
    const crate = window.subscriptionFlow.crateName || '-';
    const delivery = this.getStickyDeliveryText();
    const charge = this.getStickyChargeText();
    const pricing = this.getStickyPricing();

    if (this.sticky.plan) {
      this.sticky.plan.textContent = plan || this.root.querySelector('h1')?.textContent?.trim() || '';
    }
    if (this.sticky.payment) {
      this.sticky.payment.textContent = payment;
    }
    if (this.sticky.titleSeparator) {
      this.sticky.titleSeparator.hidden = !plan || !payment;
    }
    if (this.sticky.total) {
      this.sticky.total.textContent = total;
    }
    if (this.sticky.size) {
      this.sticky.size.textContent = size;
    }
    if (this.sticky.crate) {
      this.sticky.crate.textContent = crate;
    }
    if (this.sticky.delivery) {
      this.sticky.delivery.textContent = delivery;
    }
    if (this.sticky.charge) {
      this.sticky.charge.textContent = charge;
    }
    if (this.sticky.priceCurrent) {
      this.sticky.priceCurrent.textContent = pricing.current;
    }
    if (this.sticky.priceCompare) {
      this.sticky.priceCompare.textContent = pricing.compare;
      this.sticky.priceCompare.hidden = !pricing.compare;
    }
    if (this.sticky.priceBadge) {
      this.sticky.priceBadge.textContent = pricing.badge;
      this.sticky.priceBadge.hidden = !pricing.badge;
    }
    if (this.sticky.desktopCompare) {
      this.sticky.desktopCompare.textContent = pricing.compare;
      this.sticky.desktopCompare.hidden = !pricing.compare;
    }
    if (this.sticky.desktopBadge) {
      this.sticky.desktopBadge.textContent = pricing.badge;
      this.sticky.desktopBadge.hidden = !pricing.badge;
    }
    if (this.sticky.buttonTotal) {
      this.sticky.buttonTotal.textContent = pricing.current;
    }
    if (this.sticky.buttonCompare) {
      this.sticky.buttonCompare.textContent = pricing.compare;
      this.sticky.buttonCompare.hidden = !pricing.compare;
    }
    if (this.sticky.buttonDivider) {
      this.sticky.buttonDivider.hidden = !pricing.current || pricing.current === '-';
    }

    this.syncStickyImage();
    this.syncStickyButtonFromMain();
  }

  getSelectedPlanLabel() {
    const planInput = this.getSelectedPlanInput();
    const title = planInput
      ? planInput.closest('.sp-plan-card')?.querySelector('.plan-title')
      : null;
    return title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  getSelectedPaymentLabel() {
    const card = this.getSelectedPaymentCard();
    const title = card ? card.querySelector('.fw-semibold.mb-0') : null;
    return title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  getStickyPricing() {
    const card = this.getSelectedPaymentCard();
    const subtotalEl = card ? card.querySelector('[data-sub-total]') : null;
    const compareEl = card ? card.querySelector('.sp-price-old') : null;
    const basePriceEl = card ? card.querySelector('[data-subscription-price]') : null;
    const discountBadgeEl = card ? card.querySelector('.sp-payment-badge--discount') : null;
    const saveBadgeEl = card ? card.querySelector('.sp-payment-badge--save') : null;
    const current = subtotalEl ? subtotalEl.textContent.replace(/\s+/g, ' ').trim() : '-';
    const basePrice = basePriceEl ? basePriceEl.textContent.replace(/\s+/g, ' ').trim() : '';
    let compare = compareEl ? compareEl.textContent.replace(/\s+/g, ' ').trim() : '';
    let badge = '';

    if (!compare && basePrice && current && basePrice !== current) {
      compare = basePrice;
    }

    if (discountBadgeEl) {
      badge = this.normalizeStickyBadgeText(discountBadgeEl.textContent);
    } else if (saveBadgeEl) {
      badge = this.normalizeStickyBadgeText(saveBadgeEl.textContent);
    }

    return { current, compare, badge };
  }

  normalizeStickyBadgeText(value) {
    const text = String(value || '').replace(/\s+/g, ' ').trim();
    if (!text) {
      return '';
    }

    const saveMatch = text.match(/^save\s+(.+)$/i);
    if (saveMatch && saveMatch[1]) {
      const amount = saveMatch[1].trim().toUpperCase();
      return amount.includes('OFF') ? amount : `${amount} OFF`;
    }

    const flashSaleMatch = text.match(/^flash sale\s*-\s*(.+)$/i);
    if (flashSaleMatch && flashSaleMatch[1]) {
      return flashSaleMatch[1].trim().toUpperCase();
    }

    return text.toUpperCase();
  }

  getStickyDeliveryText() {
    return this.getEveryMonthsLabel(window.subscriptionFlow.shipFrequency);
  }

  getStickyChargeText() {
    return this.getEveryMonthsLabel(window.subscriptionFlow.payFrequency);
  }

  getEveryMonthsLabel(frequency) {
    const count = parseInt(frequency, 10);
    if (!Number.isFinite(count) || count <= 0) {
      return '-';
    }
    return `Every ${count} ${count === 1 ? 'Month' : 'Months'}`;
  }

  setStickySummaryOpen(isOpen) {
    this._stickySummaryOpen = !!isOpen;

    if (this.sticky.bar) {
      this.sticky.bar.classList.toggle('is-summary-open', this._stickySummaryOpen);
      this.sticky.bar.toggleAttribute('data-summary-open', this._stickySummaryOpen);
    }

    if (this.sticky.accordion) {
      this.sticky.accordion.classList.toggle('open', this._stickySummaryOpen);
      this.sticky.accordion.toggleAttribute('data-open', this._stickySummaryOpen);
    }

    if (this.sticky.summary) {
      this.sticky.summary.hidden = !this._stickySummaryOpen;
    }

    if (this.sticky.summaryToggle) {
      this.sticky.summaryToggle.textContent = this._stickySummaryOpen
        ? 'Hide Summary'
        : 'View Summary';
      this.sticky.summaryToggle.setAttribute('aria-expanded', String(this._stickySummaryOpen));
    }

    if (this.sticky.toggle) {
      this.sticky.toggle.setAttribute('aria-expanded', String(this._stickySummaryOpen));
      this.sticky.toggle.setAttribute(
        'aria-label',
        this._stickySummaryOpen ? 'Hide product summary' : 'Show product summary'
      );
    }
  }

  syncStickyImage() {
    if (!this.sticky.image) {
      return;
    }

    const slide =
      this.root.querySelector('.product-carousel .swiper-slide-active') ||
      (this.mainGalleryWrapper && this.mainGalleryWrapper.querySelector('.swiper-slide')) ||
      this.galleryMainSlides[0];

    const image = slide ? slide.querySelector('img') : null;
    if (!image) {
      return;
    }

    const sourceSrc = image.currentSrc || image.getAttribute('src');
    if (sourceSrc) {
      const stickyPicture = this.sticky.image.closest('picture');
      if (stickyPicture) {
        stickyPicture.querySelectorAll('source').forEach((node) => node.remove());
      }

      const capped1x = this.getShopifyImageWithWidth(sourceSrc, STICKY_THUMB_IMAGE_WIDTH_1X);
      const capped2x = this.getShopifyImageWithWidth(sourceSrc, STICKY_THUMB_IMAGE_WIDTH_2X);
      const srcToUse = capped1x || sourceSrc;

      this.sticky.image.src = srcToUse;
      if (capped1x && capped2x) {
        this.sticky.image.srcset = `${capped1x} 1x, ${capped2x} 2x`;
      } else {
        this.sticky.image.removeAttribute('srcset');
      }
    }

    const alt = image.getAttribute('alt');
    if (alt) {
      this.sticky.image.alt = alt;
    }
  }

  /**
   * Rewrites a Shopify CDN image URL to a smaller `width` query param for thumbnails.
   * @param {string} src
   * @param {number} width
   * @returns {string} Empty string when URL is not a recognized Shopify CDN image.
   */
  getShopifyImageWithWidth(src, width) {
    if (!src || !Number.isFinite(width) || width <= 0) {
      return '';
    }

    try {
      const parsed = new URL(src, window.location.origin);
      const host = parsed.hostname || '';
      const isShopifyCdn =
        /(^|\.)cdn\.shopify\.com$/i.test(host) || parsed.pathname.includes('/cdn/shop/files/');

      if (!isShopifyCdn) {
        return '';
      }

      parsed.searchParams.set('width', String(width));
      return parsed.toString();
    } catch (error) {
      console.warn('[SubscriptionProductSingle] getShopifyImageWithWidth failed', { src, width, error });
      return '';
    }
  }

  getDiscountState() {
    const flow = window.subscriptionFlow;
    const subTotal = this.parseNumeric(flow.subTotal);
    const discountValue = this.parseNumeric(flow.discount_amount);

    if (!flow.discount_code || !Number.isFinite(subTotal) || !Number.isFinite(discountValue)) {
      return { hasDiscount: false };
    }

    const isPercentage = String(flow.discount_type).toLowerCase() === 'percentage';

    let discountedTotal = subTotal;
    if (isPercentage) {
      discountedTotal = subTotal - (subTotal * discountValue) / 100;
    } else {
      discountedTotal = subTotal - discountValue;
    }

    if (!Number.isFinite(discountedTotal) || discountedTotal <= 0 || discountedTotal >= subTotal) {
      return { hasDiscount: false };
    }

    const payFrequency = parseInt(flow.payFrequency, 10);
    const shipFrequency = parseInt(flow.shipFrequency, 10);

    let discountedPerCrate = null;
    if (
      Number.isFinite(payFrequency) &&
      payFrequency > 0 &&
      Number.isFinite(shipFrequency) &&
      shipFrequency > 0
    ) {
      discountedPerCrate = (discountedTotal / payFrequency) * shipFrequency;
    }

    return {
      hasDiscount: true,
      discountedTotal,
      discountedTotalFormatted: this.formatMoney(discountedTotal),
      savingsFormatted: this.formatMoney(subTotal - discountedTotal),
      discountedPerCrateFormatted: Number.isFinite(discountedPerCrate)
        ? this.formatMoney(discountedPerCrate)
        : null
    };
  }

  getShipFrequencyLabel(shipFrequency) {
    if (!Number.isFinite(shipFrequency)) {
      return '-';
    }

    if (shipFrequency === 1) {
      return 'Monthly';
    }
    if (shipFrequency === 2) {
      return 'Bi-monthly';
    }
    if (shipFrequency === 3) {
      return '3 Months';
    }
    if (shipFrequency === 6) {
      return '6 Months';
    }
    if (shipFrequency === 12) {
      return '12 Months';
    }

    return `${shipFrequency} Months`;
  }

  mapFlowFrequency(shipFrequency) {
    if (shipFrequency === 1) {
      return 'Monthly';
    }
    if (shipFrequency === 2) {
      return 'Bi-monthly';
    }
    if (shipFrequency === 3) {
      return 'Quarterly';
    }
    if (shipFrequency === 12) {
      return 'Yearly';
    }

    return `${shipFrequency} Months`;
  }

  parseNumeric(value) {
    if (value === null || value === undefined) {
      return NaN;
    }

    const parsed = parseFloat(String(value).replace(/[^0-9.-]/g, ''));
    return Number.isFinite(parsed) ? parsed : NaN;
  }

  formatMoney(value) {
    const amount = Number(value);
    if (!Number.isFinite(amount)) {
      return '-';
    }
    return Number.isInteger(amount) ? `$${amount.toFixed(0)}` : `$${amount.toFixed(2)}`;
  }

  getSelectedPlanInput() {
    for (let i = 0; i < this.planInputs.length; i++) {
      if (this.planInputs[i].checked) {
        return this.planInputs[i];
      }
    }
    return null;
  }

  getSelectedFrequencyInput() {
    for (let i = 0; i < this.frequencyInputs.length; i++) {
      if (this.frequencyInputs[i].checked) {
        return this.frequencyInputs[i];
      }
    }
    return null;
  }

  getSelectedPaymentCard() {
    for (let i = 0; i < this.paymentCards.length; i++) {
      const card = this.paymentCards[i];
      if (card.classList.contains('d-none')) {
        continue;
      }
      const radio = card.querySelector('[data-pay-checkobox]');
      if (radio && radio.checked) {
        return card;
      }
    }
    for (let i = 0; i < this.paymentCards.length; i++) {
      if (!this.paymentCards[i].classList.contains('d-none')) {
        return this.paymentCards[i];
      }
    }
    return null;
  }

  getSelectedCrateInput() {
    for (let i = 0; i < this.crateInputs.length; i++) {
      if (this.crateInputs[i].checked) {
        return this.crateInputs[i];
      }
    }
    return null;
  }

  callCommon(method, ...args) {
    if (!this.common || typeof this.common[method] !== 'function') {
      return null;
    }

    return this.common[method].call(this.common, ...args);
  }

  isVisible(element) {
    return !!(element && element.offsetParent !== null && !element.classList.contains('d-none'));
  }

  ensureValidSelections() {
    this.filterPaymentCards();
    this.ensureSelectedPaymentCard();
    this.updateCrateAvailability();
    this.updateSizeAvailability();
    this.ensureSizeSelected(this.getActiveSizeWrap());
    this.ensureCrateSelection();
  }

  scheduleSyncFromState(delay = 1200) {
    if (this._syncTimer) {
      window.clearTimeout(this._syncTimer);
    }
    this._syncTimer = window.setTimeout(() => {
      this._syncTimer = null;
      this.syncFromState();
    }, delay);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SubscriptionProductSingle();
  });
} else {
  new SubscriptionProductSingle();
}
